export type Lang = 'es' | 'en'

export const T = {
  es: {
    nav: {
      services: 'Servicios',
      packages: 'Paquetes',
      process: 'Proceso',
      contact: 'Contacto',
      cta: 'Hablar con asesor',
    },
    urgency: {
      text1: '🔥 Solo quedan ',
      text2: ' cupos este mes — Precios especiales hasta el ',
    },
    hero: {
      tag: '● Agencia Digital — Orlando, FL',
      h1_1: 'Tu negocio',
      h1_2: 'merece clientes',
      h1_3: 'todos los días.',
      subtitle:
        'Transformamos tu presencia online en una máquina de ventas 24/7. Diseño web profesional, SEO y estrategias digitales para negocios que quieren crecer.',
      pain1:
        '¿Tu negocio no aparece en Google cuando la gente busca lo que ofreces?',
      pain2:
        '¿Tus competidores están capturando clientes que deberían ser tuyos?',
      pain3:
        '¿Tienes solo redes sociales pero ninguna presencia digital profesional?',
      btnPrimary: 'Ver paquetes y precios →',
      btnGhost: 'Hablar con asesor',
      stat1: '5–7',
      stat1L: 'días de entrega',
      stat2: '$500',
      stat2L: 'desde',
      stat3: '100%',
      stat3L: 'responsivo',
      stat4: '3×',
      stat4L: 'más visibilidad',
      cardLabel: '🔥 Más Popular Esta Semana',
      cardTitle: 'Plan Profesional — Presencia completa en Google',
      cardF1: 'Página web hasta 8 secciones',
      cardF2: 'SEO para aparecer en Google',
      cardF3: 'Integración WhatsApp + redes',
      cardF4: 'Google Analytics configurado',
      cardF5: 'Soporte 60 días incluido',
      cardPriceOnly: 'Solo',
      cardUrgency: '⚡ Solo 3 cupos disponibles este mes',
      cardBtn: 'Quiero este paquete →',
      cardNote: 'Sin contratos. Sin mensualidades. Pago único.',
    },
    pain: {
      h2_1: 'Cada día sin página web es dinero que ',
      h2_2: 'pierdes.',
      subtitle:
        'El mundo digital no espera. Si tus clientes no te encuentran a ti, encontrarán a tu competencia.',
      c1_title: '📉 Clientes que se van',
      c1_desc:
        'El 97% de los consumidores buscan en línea antes de comprar. Si no apareces, no existes.',
      c2_title: '😤 Credibilidad perdida',
      c2_desc:
        'Un negocio sin página web parece informal. La primera impresión importa.',
      c3_title: '🏆 Tu competencia gana',
      c3_desc:
        'Mientras tú piensas, ellos están en Google atrayendo tus clientes ideales.',
      c4_title: '💸 Dinero sobre la mesa',
      c4_desc:
        'Sin presencia digital, estás dejando miles de dólares sin capturar.',
      sol_1: 'La solución es simple: una página web profesional que trabaja ',
      sol_2: '24/7 para ti',
    },
    services: {
      tag: 'Lo que hacemos',
      h2_1: 'Todo lo que tu negocio necesita para ',
      h2_2: 'dominar',
      subtitle:
        'No solo hacemos páginas bonitas. Construimos ecosistemas digitales diseñados para generar confianza y ventas.',
      s1_title: '🌐 Diseño Web Profesional',
      s1_desc:
        'Páginas rápidas, modernas y adaptadas a celular. Diseño que refleja tu marca y convierte visitantes en clientes.',
      s2_title: '🔍 SEO & Posicionamiento',
      s2_desc:
        'Estrategia de palabras clave para que tus clientes te encuentren primero en Google.',
      s3_title: '📍 Google Business & Maps',
      s3_desc:
        'Configuración y optimización completa de tu perfil en Google Maps. Domina las búsquedas locales.',
      s4_title: '🛒 Tienda / Sistema de Citas',
      s4_desc: 'Acepta pagos o reservas online las 24 horas automáticamente.',
      s5_title: '📱 Redes Sociales',
      s5_desc:
        'Optimización en Facebook, Instagram, LinkedIn y TikTok. Imagen coherente en todas las plataformas.',
      s6_title: '⚡ Generación de Leads',
      s6_desc:
        'Formularios y botones de WhatsApp que convierten visitantes en prospectos calificados.',
    },
    pricing: {
      tag: 'Inversión inteligente',
      h2_1: 'Elige tu nivel de ',
      h2_2: 'crecimiento',
      subtitle:
        'Planes transparentes sin costos ocultos. Inversión única para resultados a largo plazo.',
      scarcity:
        '⚠️ Cupos limitados — Solo aceptamos 5 proyectos nuevos por mes',

      b_badge: 'Starter',
      b_name: 'Básico',
      b_old: 'Valor real: $1,250',
      b_note: 'Pago único · Sin mensualidades',
      b_save: 'Ahorras $750',
      includes: 'Incluye',
      b_f1: 'Página web de 1 a 3 secciones',
      b_f2: 'Diseño personalizado',
      b_f3: 'Copy redactado profesionalmente',
      b_f4: 'Formulario de contacto',
      b_f5: '100% responsiva',
      b_f6: 'Dominio + hosting 1 año',
      b_f7: 'Soporte por 30 días',
      b_f8: 'SEO avanzado',
      b_f9: 'Google Business',
      b_del: '⏱ Entrega en 5 a 7 días',
      b_btn: 'Empezar con Básico →',
      b_wa: 'Hola, me interesa el Plan Básico de $500. ¿Pueden asesorarme?',
      guarantee: '✓ Sin contrato · Entrega garantizada',

      p_pop: '⭐ Más Popular',
      p_badge: 'Recomendado',
      p_name: 'Profesional',
      p_old: 'Valor real: $2,050',
      p_save: 'Ahorras $1,250',
      p_inc: 'Todo del Básico, más',
      p_f1: 'Hasta 6–8 secciones',
      p_f2: 'SEO palabras clave',
      p_f3: 'Galería / portafolio',
      p_f4: 'Botón WhatsApp + redes',
      p_f5: 'Google Analytics',
      p_f6: 'Soporte 60 días',
      p_f7: 'Google Business',
      p_f8: 'Tienda o citas',
      p_del: '⏱ Entrega en 7 a 10 días',
      p_btn: 'Quiero el Plan Profesional →',
      p_wa: 'Hola, me interesa el Plan Profesional de $800. ¿Pueden asesorarme?',

      pr_badge: 'Todo incluido',
      pr_name: 'Premium',
      pr_old: 'Valor real: $3,500+',
      pr_save: 'Ahorras $2,300+',
      pr_f1: 'Páginas ilimitadas',
      pr_f2: 'SEO avanzado 10+ palabras clave',
      pr_f3: 'Tienda online o sistema de citas',
      pr_f4: 'Velocidad optimizada (Core Web Vitals)',
      pr_f5: 'Google Business 100% configurado',
      pr_f6: 'Optimización todas las redes',
      pr_f7: 'Presencia dominante Google Maps',
      pr_f8: 'Soporte prioritario 90 días',
      pr_del: '⏱ Entrega en 10 a 15 días',
      pr_btn: 'Dominar con Premium →',
      pr_wa: 'Hola, me interesa el Plan Premium de $1,200. ¿Pueden asesorarme?',
    },
    value: {
      tag: 'El valor real',
      h2_1: 'No vendemos páginas. Vendemos ',
      h2_2: 'resultados.',
      subtitle:
        'Tu página web no es un gasto, es tu mejor vendedor trabajando sin descanso.',
      f1: '🎯 Diseño orientado a conversión',
      f2: '🚀 Entrega en tiempo récord',
      f3: '🛡️ Soporte real post-entrega',
      f4: '💰 Inversión que se paga sola',
      t_head: 'Desglose de valor — Plan Profesional',
      t_r1: 'Diseño web personalizado',
      t_r2: 'Redacción de contenido',
      t_r3: 'Dominio + hosting 1 año',
      t_r4: 'SEO básico',
      t_r5: 'Galería + integraciones',
      t_r6: 'Analytics + configuración',
      t_r7: 'Soporte 60 días',
      t_total: 'Si lo contratas por separado',
      inv_label: 'Tu inversión hoy',
      inv_sub: 'Pago único · Sin sorpresas',
    },
    process: {
      tag: 'Paso a paso',
      h2_1: 'Online en días, no en ',
      h2_2: 'meses',
      subtitle:
        'Nuestro proceso está optimizado para quitarte el estrés y lanzar tu proyecto rápido.',
      s1: 'Consulta gratis',
      s2: 'Diseño y contenido',
      s3: 'Revisión contigo',
      s4: 'Publicación',
      s5: 'Soporte continuo',
    },
    contact: {
      tag: 'Hablemos',
      h2_1: '¿Listo para tener más clientes ',
      h2_2: 'mañana?',
      subtitle:
        'Agenda una llamada o escríbenos. Te daremos una asesoría honesta sin compromiso.',
      wa_title: 'Escríbenos por WhatsApp',
      wa_sub: 'Respuesta rápida garantizada',
      wa_note: '📍 Atención en español e inglés · Lun–Sáb 9am–7pm EST',
      wa_msg:
        'Hola Arvex! Me interesa una página web para mi negocio. ¿Pueden asesorarme?',
      f_title: 'Solicita información',
      f_sub:
        'Llena el formulario y te contactamos por correo o SMS en menos de 24 horas.',
      f_name: 'Nombre completo',
      f_biz: 'Nombre de tu negocio',
      f_email: 'Correo electrónico',
      f_phone: 'Teléfono',
      f_pkg: 'Paquete de interés',
      f_pkg_1: 'Básico $500',
      f_pkg_2: 'Profesional $800',
      f_pkg_3: 'Premium $1,200',
      f_pkg_4: 'Necesito asesoría',
      f_msg: 'Cuéntanos sobre tu negocio...',
      f_pref: 'Preferencia de contacto',
      f_pref_1: 'Email',
      f_pref_2: 'SMS',
      f_pref_3: 'WhatsApp',
      f_btn: 'Enviar solicitud →',
      f_btn_sending: 'Enviando...',
      f_success: '¡Mensaje enviado con éxito! Te contactaremos pronto.',
      f_error: 'Hubo un error al enviar. Por favor intenta por WhatsApp.',
      f_priv:
        'Al enviar aceptas nuestra Política de Privacidad. Nunca compartimos tus datos.',
    },
    footer: {
      desc: 'Agencia digital especializada en diseño web, SEO y crecimiento online para negocios.',
      rights: '© 2026 Arvex Holding LLC — Todos los derechos reservados.',
      priv: 'Política de Privacidad',
      terms: 'Términos de Servicio',
    },
  },
  en: {
    nav: {
      services: 'Services',
      packages: 'Packages',
      process: 'Process',
      contact: 'Contact',
      cta: 'Talk to an advisor',
    },
    urgency: {
      text1: '🔥 Only ',
      text2: ' spots left this month — Special prices until ',
    },
    hero: {
      tag: '● Digital Agency — Orlando, FL',
      h1_1: 'Your business',
      h1_2: 'deserves customers',
      h1_3: 'every single day.',
      subtitle:
        'We transform your online presence into a 24/7 sales machine. Professional web design, SEO, and digital strategies for businesses that want to grow.',
      pain1:
        'Does your business not appear on Google when people search for what you offer?',
      pain2: 'Are your competitors capturing customers that should be yours?',
      pain3:
        'Do you only have social media but no professional digital presence?',
      btnPrimary: 'See packages & pricing →',
      btnGhost: 'Talk to an advisor',
      stat1: '5–7',
      stat1L: 'days delivery',
      stat2: '$500',
      stat2L: 'starting at',
      stat3: '100%',
      stat3L: 'responsive',
      stat4: '3×',
      stat4L: 'more visibility',
      cardLabel: '🔥 Most Popular This Week',
      cardTitle: 'Professional Plan — Full Google Presence',
      cardF1: 'Website up to 8 sections',
      cardF2: 'SEO to appear on Google',
      cardF3: 'WhatsApp + social integration',
      cardF4: 'Google Analytics configured',
      cardF5: '60-day support included',
      cardPriceOnly: 'Only',
      cardUrgency: '⚡ Only 3 spots available this month',
      cardBtn: 'I want this package →',
      cardNote: 'No contracts. No monthly fees. One-time payment.',
    },
    pain: {
      h2_1: "Every day without a website is money you're ",
      h2_2: 'losing.',
      subtitle:
        "The digital world doesn't wait. If your clients don't find you, they'll find your competition.",
      c1_title: '📉 Clients walking away',
      c1_desc:
        "97% of consumers search online before buying. If you don't appear, you don't exist.",
      c2_title: '😤 Lost credibility',
      c2_desc:
        'A business without a website looks informal. First impressions matter.',
      c3_title: '🏆 Your competition wins',
      c3_desc:
        "While you think, they're on Google capturing your ideal customers.",
      c4_title: '💸 Money on the table',
      c4_desc: "Without digital presence, you're leaving thousands uncaptured.",
      sol_1: 'The solution is simple: a professional website that works ',
      sol_2: '24/7 for you',
    },
    services: {
      tag: 'What we do',
      h2_1: 'Everything your business needs to ',
      h2_2: 'dominate',
      subtitle:
        'We don’t just make pretty pages. We build digital ecosystems designed to build trust and generate sales.',
      s1_title: '🌐 Professional Web Design',
      s1_desc:
        'Fast, modern, mobile-friendly pages. Design that reflects your brand and converts visitors into clients.',
      s2_title: '🔍 SEO & Rankings',
      s2_desc: 'Keyword strategy so your clients find you first on Google.',
      s3_title: '📍 Google Business & Maps',
      s3_desc: 'Full Google Maps profile setup. Dominate local searches.',
      s4_title: '🛒 Online Store / Booking',
      s4_desc: 'Accept payments or bookings online 24 hours automatically.',
      s5_title: '📱 Social Media',
      s5_desc:
        'Optimization on Facebook, Instagram, LinkedIn and TikTok. Cohesive image across platforms.',
      s6_title: '⚡ Lead Generation',
      s6_desc:
        'Forms and WhatsApp buttons that convert visitors into qualified leads.',
    },
    pricing: {
      tag: 'Smart investment',
      h2_1: 'Choose your level of ',
      h2_2: 'growth',
      subtitle:
        'Transparent plans with no hidden costs. One-time investment for long-term results.',
      scarcity: '⚠️ Limited spots — We only accept 5 new projects per month',

      b_badge: 'Starter',
      b_name: 'Basic',
      b_old: 'Real value: $1,250',
      b_note: 'One-time payment · No monthly fees',
      b_save: 'You save $750',
      includes: 'Includes',
      b_f1: 'Website 1 to 3 sections',
      b_f2: 'Custom design',
      b_f3: 'Professional copy',
      b_f4: 'Contact form',
      b_f5: '100% responsive',
      b_f6: 'Domain + hosting 1 year',
      b_f7: '30-day support',
      b_f8: 'Advanced SEO',
      b_f9: 'Google Business',
      b_del: '⏱ Delivery in 5 to 7 days',
      b_btn: 'Start with Basic →',
      b_wa: 'Hello, I am interested in the $500 Basic Plan. Can you advise me?',
      guarantee: '✓ No contract · Guaranteed delivery',

      p_pop: '⭐ Most Popular',
      p_badge: 'Recommended',
      p_name: 'Professional',
      p_old: 'Real value: $2,050',
      p_save: 'You save $1,250',
      p_inc: 'Everything in Basic, plus',
      p_f1: 'Up to 6–8 sections',
      p_f2: 'SEO keywords',
      p_f3: 'Gallery / portfolio',
      p_f4: 'WhatsApp + social buttons',
      p_f5: 'Google Analytics',
      p_f6: '60-day support',
      p_f7: 'Google Business',
      p_f8: 'Store or booking',
      p_del: '⏱ Delivery in 7 to 10 days',
      p_btn: 'I want the Professional Plan →',
      p_wa: 'Hello, I am interested in the $800 Professional Plan. Can you advise me?',

      pr_badge: 'All included',
      pr_name: 'Premium',
      pr_old: 'Real value: $3,500+',
      pr_save: 'You save $2,300+',
      pr_f1: 'Unlimited pages',
      pr_f2: 'Advanced SEO 10+ keywords',
      pr_f3: 'Online store or booking',
      pr_f4: 'Optimized speed (Core Web Vitals)',
      pr_f5: 'Google Business fully configured',
      pr_f6: 'All social media optimized',
      pr_f7: 'Google Maps dominance',
      pr_f8: 'Priority 90-day support',
      pr_del: '⏱ Delivery in 10 to 15 days',
      pr_btn: 'Dominate with Premium →',
      pr_wa:
        'Hello, I am interested in the $1,200 Premium Plan. Can you advise me?',
    },
    value: {
      tag: 'The real value',
      h2_1: "We don't sell pages. We sell ",
      h2_2: 'results.',
      subtitle:
        'Your website is not an expense, it is your best salesperson working tirelessly.',
      f1: '🎯 Conversion-focused design',
      f2: '🚀 Record-time delivery',
      f3: '🛡️ Real post-delivery support',
      f4: '💰 Investment that pays itself',
      t_head: 'Value breakdown — Professional Plan',
      t_r1: 'Custom web design',
      t_r2: 'Content copywriting',
      t_r3: 'Domain + hosting 1 year',
      t_r4: 'Basic SEO',
      t_r5: 'Gallery + integrations',
      t_r6: 'Analytics + setup',
      t_r7: '60-day support',
      t_total: 'If hired separately',
      inv_label: 'Your investment today',
      inv_sub: 'One-time payment · No surprises',
    },
    process: {
      tag: 'Step by step',
      h2_1: 'Online in days, not ',
      h2_2: 'months',
      subtitle:
        'Our process is optimized to take the stress away and launch your project fast.',
      s1: 'Free consultation',
      s2: 'Design & content',
      s3: 'Review with you',
      s4: 'Launch',
      s5: 'Ongoing support',
    },
    contact: {
      tag: "Let's talk",
      h2_1: 'Ready to have more clients ',
      h2_2: 'tomorrow?',
      subtitle:
        'Schedule a call or write to us. We will give you honest advice with no obligation.',
      wa_title: 'Write to us on WhatsApp',
      wa_sub: 'Fast response guaranteed',
      wa_note: '📍 Support in English & Spanish · Mon–Sat 9am–7pm EST',
      wa_msg:
        'Hello Arvex! I am interested in a website for my business. Can you advise me?',
      f_title: 'Request information',
      f_sub:
        'Fill out the form and we will contact you by email or SMS in less than 24 hours.',
      f_name: 'Full name',
      f_biz: 'Business name',
      f_email: 'Email address',
      f_phone: 'Phone number',
      f_pkg: 'Package of interest',
      f_pkg_1: 'Basic $500',
      f_pkg_2: 'Professional $800',
      f_pkg_3: 'Premium $1,200',
      f_pkg_4: 'I need advice',
      f_msg: 'Tell us about your business...',
      f_pref: 'Contact preference',
      f_pref_1: 'Email',
      f_pref_2: 'SMS',
      f_pref_3: 'WhatsApp',
      f_btn: 'Send request →',
      f_btn_sending: 'Sending...',
      f_success: 'Message sent successfully! We will contact you soon.',
      f_error: 'There was an error sending. Please try via WhatsApp.',
      f_priv:
        'By submitting you accept our Privacy Policy. We never share your data.',
    },
    footer: {
      desc: 'Digital agency specializing in web design, SEO, and online growth for businesses.',
      rights: '© 2026 Arvex Holding LLC — All rights reserved.',
      priv: 'Privacy Policy',
      terms: 'Terms of Service',
    },
  },
}
